module.exports = "<body>\n  <splash-screen></splash-screen>\n  <router-outlet></router-outlet>\n</body>"